<div class="df-laptop-up landing-page pr-large-t">
  <div class="country-selector-wrapper">
    <div class="country-selector align-center">
      <fcom-icon
        class="finnair-logo nordic-blue-900-text text-icon-primary mr-large-y"
        [category]="IconLibrary.CUSTOM"
        [name]="CustomIcon.FINNAIR_LOGO"
      />
      <fin-country-and-language-selector
        [useH1]="true"
        [prefill]="false"
        [showCloseButton]="false"
        (applySelection)="applySelection($event)"
      />
      <div class="ms-large-t font-body-2 font-body-small">Your country wasn't listed?</div>
      <a class="nordic-blue-900-text text-icon-primary font-body-2 font-body-small" href="/en"
        >Go to the international site</a
      >
    </div>
  </div>
  <div
    *ngIf="imageUrl$ | async"
    class="image-wrapper dn-laptop-down"
    [ngStyle]="{ 'background-image': 'url(' + (imageUrl$ | async) + ')' }"
  ></div>
</div>
